/* Langsomt Nok CRO 14. UI interactions only; never substitutes Shopify commerce events. */
(function () {
  'use strict';
  if (window.__lnAnalytics14) return;
  window.__lnAnalytics14 = true;
  var script = document.querySelector('script[data-ln-analytics-14]');
  var mode = script ? script.getAttribute('data-mode') : 'qa';
  var shopify = window.Shopify || {};
  var preview = false;
  try { preview = new URL(window.location.href).searchParams.has('preview_theme_id'); } catch (error) {}
  // Explicit QA mode is intentional. Do not enable until the downstream tags have been verified.
  if (mode !== 'live' || shopify.designMode === true || preview) return;
  if (!shopify.customerPrivacy && typeof shopify.loadFeatures === 'function') {
    try { shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {}); } catch (error) {}
  }
  function allowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    try { return !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true); }
    catch (error) { return false; }
  }
  function token(value, max) {
    if (typeof value !== 'string' && typeof value !== 'number') return undefined;
    var text = String(value);
    return text.length <= max && /^[a-zA-Z0-9_-]+$/.test(text) ? text : undefined;
  }
  function publicPath(value) {
    if (typeof value !== 'string') return undefined;
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin) return undefined;
      // Do not send query strings, checkout tokens, customer paths or contact details.
      return /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:products|collections|blogs|pages)\/[a-z0-9\/-]+$/.test(url.pathname) ? url.pathname : undefined;
    } catch (error) { return undefined; }
  }
  function send(raw, source) {
    if (!allowed() || !raw || !/^[a-z][a-z0-9_]{0,63}$/.test(raw.event || '')) return;
    var name = raw.event;
    if (source === 'click') {
      if (name === 'begin_checkout') name = 'checkout_click';
      if (name === 'remove_from_cart') name = 'cart_remove_click';
      if (name === 'add_to_cart') name = 'add_to_cart_click';
    }
    var payload = {event: 'ln_ui_' + name, interaction_source: source};
    var strings = {
      product_handle: raw.product_handle || raw.product,
      placement: raw.placement,
      source_product: raw.source_product,
      target_product: raw.target_product,
      addon_variant_id: raw.addon_variant_id,
      base_variant_id: raw.base_variant_id
    };
    Object.keys(strings).forEach(function (key) {
      var value = token(strings[key], 160);
      if (value !== undefined) payload[key] = value;
    });
    ['base_quantity', 'addon_count'].forEach(function (key) {
      if (Number.isSafeInteger(raw[key]) && raw[key] >= 0) payload[key] = raw[key];
    });
    if (typeof raw.selected === 'boolean') payload.selected = raw.selected;
    var path = publicPath(raw.link_url);
    if (path) payload.link_path = path;
    window.dataLayer = window.dataLayer || [];
    if (typeof window.dataLayer.push === 'function') window.dataLayer.push(payload);
  }
  document.addEventListener('ln:event', function (event) { send(event.detail, 'component'); });
  document.addEventListener('click', function (event) {
    var element = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
    var target = element && element.closest('[data-ln-event]');
    if (!target || target.tagName === 'DETAILS' || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
    send({event: target.dataset.lnEvent, product_handle: target.dataset.lnProduct, link_url: target.getAttribute('href'), placement: target.dataset.lnPlacement}, 'click');
  });
  document.addEventListener('toggle', function (event) {
    var target = event.target;
    if (target && target.matches && target.matches('details[data-ln-event]') && target.open) send({event: target.dataset.lnEvent}, 'disclosure');
  }, true);
  // Consent is checked on every interaction. No pre-consent queue and no retrospective replay.
})();
